export interface PlaceOption {
  label: string;
  lat: number;
  lng: number;
  distanceKm: number;
}

export const locations: PlaceOption[] = [
  { label: 'Thonglor, Bangkok', lat: 13.731, lng: 100.583, distanceKm: 9 },
  { label: 'Silom, Bangkok', lat: 13.7262, lng: 100.5302, distanceKm: 7 },
  { label: 'Ari, Bangkok', lat: 13.7797, lng: 100.5446, distanceKm: 1 },
  { label: 'Charoen Krung, Bangkok', lat: 13.7275, lng: 100.5145, distanceKm: 8 },
  { label: 'Nimman, Chiang Mai', lat: 18.7983, lng: 98.9671, distanceKm: 585 },
  { label: 'Pattaya', lat: 12.9236, lng: 100.8825, distanceKm: 145 },
  { label: 'Hua Hin', lat: 12.5684, lng: 99.9577, distanceKm: 190 },
  { label: 'Khao Yai', lat: 14.517, lng: 101.383, distanceKm: 165 },
  { label: 'Patong, Phuket', lat: 7.8964, lng: 98.2961, distanceKm: 690 },
  { label: 'Koh Samui', lat: 9.512, lng: 100.0136, distanceKm: 560 },
];
